<template>
  <div>
    <a href="#" class="back-to-search" @click.prevent="refreshPage">
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Arrows chevrons 16px">
          <path
            id="Path 3"
            d="M8.23145 10L4.23145 6L8.23145 2"
            stroke="#96154A"
            stroke-linecap="round"
          />
        </g>
      </svg>
      <span>{{ $t('tracking.info.returnBtnLabel') }}</span>
    </a>

    <div class="tracking-info">
      <div
        v-if="$store.state.estimatedDeliveryDate && $store.state.showEstimatedDeliveryDate"
        class="tracking-info__estimated-date-banner"
      >
        <span class="tracking-info__paper-plane">
          <img src="/Scripts/vue/tracking/img/paper_plane.svg" alt="" />
        </span>
        <span
          >{{ $t('tracking.info.estimatedDateSentence')
          }}<strong>{{ estimatedDateFormatted }}</strong></span
        >
      </div>

      <div v-else class="tracking-info__update-banner">
        <span
          >{{ $t('tracking.info.updatedLabel') }}{{ updateDate }}
          {{ $t('tracking.info.updatedComplementLabel') }}{{ updateTime }}</span
        >
        <span class="tracking-info__update-time">
          <img
            src="/Scripts/vue/tracking/img/ico_valid.svg"
            :alt="$t('tracking.alt.valid_picto')"
          />
        </span>
      </div>

      <div class="tracking-info__header">
        <div class="tracking-info__details">
          <div class="tracking-info__detail">
            <span class="tracking-info__label">{{ $t('tracking.info.trackingNumber') }}</span>
            <span class="tracking-info__value">{{ trackingNumber }}</span>
          </div>
          <div class="tracking-info__detail">
            <span class="tracking-info__label">{{ $t('tracking.info.statusLabel') }}</span>
            <span class="tracking-info__value">{{ status }}</span>
          </div>
          <div class="tracking-info__detail tracking-info__detail--shipper">
            <span class="tracking-info__label">{{ $t('tracking.info.shipperLabel') }}</span>
            <span class="tracking-info__value">{{ shipper }}</span>
          </div>
          <div class="tracking-info__detail tracking-info__detail--icon">
            <span class="tracking-info__label"></span>
            <span class="tracking-info__value">
              <template v-if="naturePointsRelais === 'C'">
                <img src="/Scripts/vue/tracking/img/locker-icon.svg" alt="" />
              </template>
              <template v-else>
                <img src="/Scripts/vue/tracking/img/icon-relais.svg" alt="" />
              </template>
            </span>
          </div>
        </div>
      </div>
      <div class="grey-line"></div>
    </div>
  </div>
</template>

<script>
import { isoToLocaleDate } from '@/utils';
export default {
  props: {
    trackingNumber: String,
    status: String,
    shipper: String,
    updateDate: String,
    updateTime: Number,
    deliveryCheckpoints: Array,
    deliveryDate: String,
    deliveryTime: String,
    naturePointsRelais: {
      type: String,
      required: true,
    },
  },
  methods: {
    shareCode() {
      window.open('https://8a9s.adj.st?adj_t=1gjvjhl6_1gw0tj2u', '_blank');
    },
    refreshPage() {
      const cleanUrl = window.location.origin + window.location.pathname;
      window.location.href = cleanUrl;
    },
  },
  computed: {
    estimatedDateFormatted() {
      const iso = this.$store.state.estimatedDeliveryDate;
      if (!iso) return '';

      const lang = this.$store.state.nameLangue;
      const locale =
        lang.length === 4 && !lang.includes('-') ? `${lang.slice(0, 2)}-${lang.slice(2)}` : lang;

      return isoToLocaleDate(iso, locale);
    },
  },
};
</script>

<style scoped lang="scss">
@import './TrackingInfoHeader.scss';
</style>
